import { Fragment, FunctionComponent, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CheckIcon } from "@App/Components/common/Icons";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { State } from "@App/state";
import { Headline } from "@App/Components/atoms/common/Headline";

export type DeliverySummaryProps = {};

export const DeliverySummary: FunctionComponent<
  DeliverySummaryProps
> = ({}: DeliverySummaryProps) => {
  const { t } = useTranslation(); // i18next

  const navigate = useNavigate();

  const contractDetails = useSelector((state: State) => state.orders.contractDetails);
  const date1 = useSelector((state: State) => state.orders.deliveryDates.date1);
  const date2 = useSelector((state: State) => state.orders.deliveryDates.date2);
  const date3 = useSelector((state: State) => state.orders.deliveryDates.date3);

  // redirect back to start if parameters are missing
  useEffect(() => {
    if (!contractDetails || !date1 || !date2 || !date3) {
      navigate("/partner/mobility-concept/fahrzeuglieferung");
    }
  }, []);

  return (
    <Fragment>
      <div
        className={
          "container md:w-[600px] m-5 h-[calc(100vh-150px)] flex items-start md:items-center mx-auto"
        }
      >
        <div>
          <CheckIcon
            className={"w-14 h-14 border-2 border-primary rounded-full p-3 mb-3"}
            primary
          />
          <Headline type="h1">{t("vehicleDelivery.summary-headline")}</Headline>
          <p className={"text-neutral-500 mb-3"}>{t("vehicleDelivery.summary-text-1")}</p>
          <p
            className={"text-neutral-500"}
            dangerouslySetInnerHTML={{ __html: t("vehicleDelivery.summary-text-2") }}
          ></p>
        </div>
      </div>
    </Fragment>
  );
};
